var fogDualColorPS = `
#ifndef FOG_DUAL_COLOR
#define FOG_DUAL_COLOR
uniform vec3 fog_color;
uniform float fog_density;
uniform float fog_start;
uniform float fog_end;
float dBlendModeFogFactor = 1.0;
const vec3 FOG_SKY_COLOR = vec3(137, 202, 255) / 255.0;
vec3 addFogDualColor(vec3 color, vec3 I) {
	float depth = gl_FragCoord.z / gl_FragCoord.w;
	vec3 skyFogColor = gammaCorrectInput(FOG_SKY_COLOR);
	vec3 horizonFogColor = gammaCorrectInput(fog_color);
	float horizonMaxAngle = 0.1;
	float horizonFactor = clamp(I.y / horizonMaxAngle, 0.0, 1.0);
	vec3 interpolatedFogColor = mix(skyFogColor, horizonFogColor, horizonFactor);
	float adjustedDepth = mix(max(depth - fog_start, 0.0), max(depth - fog_end, 0.0), horizonFactor);
	float fogFactor = 1.0 - exp(-adjustedDepth * adjustedDepth * fog_density * fog_density * fog_density * fog_density);
	fogFactor = clamp(fogFactor, 0.0, 1.0);
	float horizonFogFactor = clamp(fogFactor * (1.0 + (horizonFactor * 0.65)), 0.0, 1.0);
	return mix(color, interpolatedFogColor, horizonFogFactor);
}
#endif
`;

export { fogDualColorPS as default };
